import { components } from '@doltech/dto';
import { isNotEmpty } from '@doltech/utils/lib/text';
import { types as t } from 'mobx-state-tree';

import { VocabModel } from './vocab';

export const AbstractVocab = t
  .model('AbstractVocab', {
    vocabs: t.optional(t.array(VocabModel), []),
    vocabUrl: t.maybe<any>(t.string),
    totalWords: t.maybe(t.number),
  })
  .actions((self) => ({
    initData(data: components['schemas']['VocabDataDTO']) {
      self.totalWords = data.totalWords;
      self.vocabUrl = data.vocabUrl;
      self.vocabs.replace(data.vocabs as any);
    },
  }))
  .views((self) => ({
    get numberOfMeaning() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.meaning));
      return result?.length || 0;
    },
    get numberOfWords() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.value));
      return result?.length || 0;
    },
    get numberOfType() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.type));
      return result?.length || 0;
    },
    get numberOfGroup() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.group));
      return result?.length || 0;
    },
    get numberOfPronounce() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.pronounce));
      return result?.length || 0;
    },
    get numberOfImage() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.image));
      return result?.length || 0;
    },
    get numberOfExample() {
      const result = self.vocabs.filter((item) => isNotEmpty(item.example));
      return result?.length || 0;
    },
    isValid() {
      return (
        this.numberOfExample === self.totalWords &&
        this.numberOfGroup === self.totalWords &&
        this.numberOfImage === self.totalWords &&
        this.numberOfMeaning === self.totalWords &&
        this.numberOfPronounce === self.totalWords &&
        this.numberOfType === self.totalWords &&
        this.numberOfWords === self.totalWords
      );
    },
  }));
